<!-- 表单 -->
<template>
	<div class='page_content'>
		<div class="page_content_top">
			<!-- <div class="page_content_top_line">
				<el-alert title="非管理人员勿动" type="error"  effect="dark">
				</el-alert>
			</div> -->
			<div class="page_content_top_line">
				<el-cascader 
					:options="systemFormList" 
					placeholder="请选择要操作的表单"  
					:props="{ expandTrigger: 'hover' }" 
					size="small" style="width: 100%;" 
					v-model="selectForm" 
					@change="selectFormAction">
					<template slot-scope="{ node, data }">
						<span>{{ data.label }}</span>
						<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
					</template>
				</el-cascader>
			</div>
		</div>
		<div class="page_content_center">
			<!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick"> -->
			<el-tabs type="border-card" v-model="activeName" class="el-tabs-box">
				
			    <el-tab-pane 
					:label="settingValue.jciName" 
					:name="settingKye+'--'" 
					class="el-tabs-content" 
					v-for="(settingValue,settingKye) in settingData" :key="settingKye">
				
					<!-- 表单设计 -->
					<div style="height: 500px;" v-if="settingValue.isForm == 1">
						<el-table stripe  :data="settingValue.jurconfigform" height="100%"   border style="height:100%;width: 100%"  highlight-current-row>
							<el-table-column  type="index"  width="50" label="编号">
							</el-table-column>
							<el-table-column prop="chineseField" label="字段名称">
							</el-table-column>
							<el-table-column prop="showField" label="显示名称" >
								<template slot-scope="scope">
									<el-input v-model="scope.row.showField" size="mini" placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="isChange" label="是否可修改" >
								<template slot-scope="scope">
									<el-radio-group v-model="scope.row.isChange" :disabled="scope.row.modifyChange == 0 ? true : false"  size="mini">
									    <el-radio-button :label="0">禁止修改</el-radio-button>
									    <el-radio-button :label="1">可以修改</el-radio-button>
									</el-radio-group>
								</template>
							</el-table-column>
							<el-table-column prop="isShow" label="是否可显示" >
								<template slot-scope="scope">
									<el-radio-group v-model="scope.row.isShow" :disabled="scope.row.modifyShow == 0 ? true : false"  size="mini">
									    <el-radio-button :label="0">隐藏</el-radio-button>
										<el-radio-button :label="1">显示</el-radio-button>
									</el-radio-group>
								</template>
							</el-table-column>
							
							<el-table-column prop="operatType" label="数据操作类型" >
								<template slot-scope="scope">
									<el-radio-group v-if="scope.row.isReserved == 1" v-model="scope.row.operatType"  size="mini">
									    <el-radio-button :label="0">手动录入</el-radio-button>
									    <el-radio-button :label="1">关联选择</el-radio-button>
									</el-radio-group>
									<div v-if="scope.row.isReserved == 0">
										系统预留
									</div>
								</template>
							</el-table-column>
							
							<el-table-column prop="operatType" label="数据来源" >
								<template slot-scope="scope">
									<div v-show="false">{{scope.row.selectComponents = [scope.row.dsmName,scope.row.dsmField]}}</div>
									<el-cascader 
									v-if="scope.row.isReserved == 1"
									:disabled="scope.row.operatType==0 ? true : false" 
									:options="fieldSelectList" v-model="scope.row.selectComponents" 
									@change="selectDataPath(settingKye,scope.$index,scope.row)">
									</el-cascader>
									<!-- {{[scope.row.dsmName,scope.row.dsmField]}} -->
									<div v-if="scope.row.isReserved == 0">
										系统预留
									</div>
								</template>
							</el-table-column>
							
							<el-table-column prop="showField" label="操作">
								<template slot-scope="scope">
									<el-button type="primary" size="mini" @click="setFieldData(scope.row,1)" >保存</el-button>
								</template>
							</el-table-column>
						</el-table>
						
					</div>
					
					<!-- 表单设计 -->
					<div style="height: 500px;" v-if="settingValue.isForm == 0">
						<el-table stripe :data="settingValue.jurconfigtable"  border height="100%"   border style="height:100%;width: 100%" highlight-current-row>
							<el-table-column  type="index"  width="50" label="编号">
							</el-table-column>
							<el-table-column prop="chineseField" label="字段名称">
							</el-table-column>
							<el-table-column prop="showField" label="显示名称">
								<template slot-scope="scope">
									<el-input v-model="scope.row.showField" size="mini" placeholder="请输入显示名称"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="isShow" label="是否显示" >
								<template slot-scope="scope">
									<el-radio-group v-model="scope.row.isShow" :disabled="scope.row.modifyShow == 0 ? true : false"  size="mini">
										<el-radio-button :label="0">隐藏</el-radio-button>
										<el-radio-button :label="1">显示</el-radio-button>
									</el-radio-group>
								</template>
							</el-table-column>
							
							<el-table-column prop="showField" label="操作">
								<template slot-scope="scope">
									<el-button type="primary" size="mini" @click="setFieldData(scope.row,0)" >保存</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					
				</el-tab-pane>
			</el-tabs>
			
		</div>
		<div class="page_content_bottom">
			非技术人员请勿动
		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		var _this = this
		//这里存放数据
		return {
			dataActionBox:{
				showStatus:false,
				openMode:'ltr'||'rtl',
				boxTitle:'',
				actionType:0, // 0新增，1修改
			},
			buttonList:[],
			dataList:[],
			selectedDataList:[],
			
			sendDataInfo: {
				jteId:'',
				jteName: '',
				jurtemre:[],
			},
	
			
			systemFormList:[],
			
			settingData:[],
			selectForm:'',
			activeName:'',
			fieldSelectList:[],
			testData:'',
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		// selectForm:{
		// 	console.log(this.selectForm)
		// },
	},
	//方法集合
	methods: {
		// 提交要修改的内容
		async setFieldData(data,isForm){
			var sendDataInfo = {}
			if(isForm==0){
				sendDataInfo.isForm = isForm
				sendDataInfo.jurconfigtable = data
			}else{
				sendDataInfo.isForm = isForm
				sendDataInfo.jurconfigform = data
			}
			
			let responseData =  await this.$http.setFieldSelec(sendDataInfo)
			if(responseData.status == 200){
				this.$message({
					message: '操作成功',
					type: 'success'
				});
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		// 修改数据来源
		selectDataPath(numberOne,numberTwo,data){
			var thisData = this.settingData[numberOne].jurconfigform[numberTwo]
			thisData.dsmName = thisData.selectComponents[0]
			thisData.dsmField = thisData.selectComponents[1]
			// console.log(thisData.selectComponents)
			// console.log(thisData)
		},
		selectFormAction(){
			// console.log(this.selectForm[1])
			this.getMenuSetupList(this.selectForm[1])
		},
		// 获取系统可选项
		async getFieldSelectList(){
			let responseData =  await this.$http.getFieldSelectList()
			if(responseData.status == 200){
				// console.log(responseData.result)
				this.fieldSelectList = []
				responseData.result.forEach((itemOneValue,itemKeyValue)=>{
					this.fieldSelectList.push({
						value:itemOneValue.sosDesig,
						label:itemOneValue.sosName,
						children:[],
					})
					itemOneValue.optionsfields.forEach(item=>{
						this.fieldSelectList[itemKeyValue].children.push({
							value:item.sofField,
							label:item.sofName,
						})
					})
				})
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
			
		},
		
		// 获取菜单可配置项
		async getMenuSetupList(id){
			let responseData =  await this.$http.getMenuSetupList({ids:[id]})
			if(responseData.status == 200){
				// console.log(responseData.result)
				this.settingData = responseData.result
				if(this.settingData.length>=1){
					this.activeName = 0+'--'
				}
				// this.getJurisdictionList()
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
			
		},
		// 获取可定制的菜单列表
		async getYesCustomMenuList(){
			let responseData =  await this.$http.getYesCustomMenuList()
			if(responseData.status == 200){
				this.systemFormList = []
				responseData.result.forEach((itemValue,itemKey)=>{
					if(itemValue.jurStype == 1){
						var sendDataOne = {
							value:itemValue.jurId,
							label:itemValue.jurName,
							children:[],
							
						}
						this.systemFormList.push(sendDataOne)
					}
				})
				
				this.systemFormList.forEach((listOne,listKey)=>{
					responseData.result.forEach((itemValue,itemKey)=>{
						if(itemValue.jurParentid == listOne.value){
							var sendDataOne = {
								value:itemValue.jurId,
								label:itemValue.jurName,
								
							}
							this.systemFormList[listKey].children.push(sendDataOne)
						}
					})
				})
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
			
			
		},
	
		
		
		
		
	
		
		
		selecDataAction(data){
			this.selectedDataList =  data
		},
		
		
		
		
		
		
		
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getYesCustomMenuList()
		this.getFieldSelectList()
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.el-tabs__content{
	height: 90% !important;
}
</style>
